import {api} from '../api/robyBackend';

const downloadFile = async (app, sessionId) => {
  try {
    const response = await api.post(`/chat/${app}/${sessionId}/download/`, null, {
      responseType: 'blob', // Hier wird der responseType korrekt eingebunden
    });
    const blob = new Blob([response.data], { type: response.headers['content-type'] });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    const disposition = response.headers['content-disposition'];
    const serverName = disposition?.match(/filename=([^;]+)/)?.[1]?.trim();
    link.download = serverName || 'report.docx';
    link.click();
    window.URL.revokeObjectURL(link.href); // Freigeben des Objekt-URLs nach dem Download
  } catch (error) {
    console.error('Error downloading the file:', error);
  }
};

export default downloadFile;
